import * as React from "react";
import type { SVGProps } from "react";
const SvgCity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M22.214 22.594v-7.502h-8.08v7.502H12.73v-8.908h4.742v-8.02h-1.58V2.524H14.1V0h-1.406v2.524h-1.789v3.142h-1.58v16.928H7.919V8.808H1.786v13.786H0V24h24v-1.406zM14.266 7.402h1.407v1.406h-1.407zm0 3.142h1.407v1.406h-1.407zM5.525 22.042H4.118v-1.406h1.407zm0-3.364H4.118v-1.406h1.407zm0-3.364H4.118v-1.406h1.407zm0-3.364H4.118v-1.406h1.407zm7.006 0h-1.407v-1.406h1.406zm0-3.142h-1.407V7.402h1.406zm.164-4.548h1.406v1.406h-1.406zm4.602 18.334H15.89V16.95h1.407zm3.162 0h-1.407V16.95h1.407z"
    />
  </svg>
);
export default SvgCity;
